module.exports = __webpack_public_path__ + "img/fon-krugi.4490c7b3.png";